var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPinata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ade194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ca44"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.93 .369 -.369 .93 140.723 -418.391)",
    gradientUnits: "userSpaceOnUse",
    x1: 204.025,
    x2: 188.692,
    xlinkHref: "#lg1",
    y1: 475.856,
    y2: 503.856
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.93 .369 -.369 .93 140.723 -418.391)",
    gradientUnits: "userSpaceOnUse",
    x1: 171.32,
    x2: 167.32,
    xlinkHref: "#lg2",
    y1: 496.834,
    y2: 523.501
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#af66da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8212,
    stopColor: "#874ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#6f3f8a"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.93 .369 -.369 .93 140.723 -418.391)",
    gradientUnits: "userSpaceOnUse",
    x1: 141.994,
    x2: 195.349,
    xlinkHref: "#lg3",
    y1: 532.687,
    y2: 628.281
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.863,
    x2: 151.53,
    xlinkHref: "#lg4",
    y1: 438.379,
    y2: 500.379
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#ffd970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5288,
    stopColor: "#ffc35e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#fe9f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.667,
    x2: 177.975,
    xlinkHref: "#lg5",
    y1: 413.682,
    y2: 413.682
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.18,
    x2: 141.18,
    xlinkHref: "#lg6",
    y1: 481,
    y2: 335.074
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.364,
    x2: 431.03,
    xlinkHref: "#lg4",
    y1: 438.379,
    y2: 500.379
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 376,
    x2: 452.073,
    xlinkHref: "#lg5",
    y1: 413.682,
    y2: 413.682
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.417,
    x2: 418.417,
    xlinkHref: "#lg6",
    y1: 483,
    y2: 374.967
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.076,
    x2: 292.743,
    xlinkHref: "#lg1",
    y1: 293.198,
    y2: 409.198
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.826,
    x2: 279.826,
    y1: 400,
    y2: 304.664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017b4e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8184,
    stopColor: "#016c44",
    stopOpacity: 0.818
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 277,
    x2: 277,
    xlinkHref: "#lg2",
    y1: 237.856,
    y2: 318.41
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.974,
    x2: 377.641,
    y1: 357.891,
    y2: 268.557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0272d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.795,
    x2: 441.188,
    xlinkHref: "#lg3",
    y1: 158.795,
    y2: 286.188
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.549,
    x2: 385.549,
    y1: 302,
    y2: 148.292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af66da",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2142,
    stopColor: "#a660cf",
    stopOpacity: 0.218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#8d51b0",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#6f3f8a"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.531,
    x2: 415.207,
    xlinkHref: "#lg5",
    y1: 23.41,
    y2: 172.436
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.405,
    x2: 388.371,
    xlinkHref: "#lg4",
    y1: 103.491,
    y2: 103.491
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.263,
    x2: 488.482,
    xlinkHref: "#lg2",
    y1: 101.598,
    y2: 165.258
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m107.184 43.016c-12.206-4.804-24.719-7.522-37.146-8.324-17.958-1.159-23.547 23.866-6.766 30.364.53.205 1.06.414 1.589.628 63.389 25.54 96.601 96.979 70.924 160.313-1.024 2.525-5.046 4.998-6.215 7.417-5.375 11.118 8.563 21.58 17.503 13.062 12.637-12.041 22.901-26.98 29.667-44.332 24.511-62.856-6.779-134.418-69.556-159.128z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.044 69.532c-13.057-1.259-25.835-.428-38.002 2.222-17.583 3.829-16.069 29.426 1.852 31.053.566.051 1.133.107 1.7.166 67.97 7.106 119.194 67.449 111.941 135.404-.289 2.709-3.107 5.389-3.565 8.036-2.107 12.168 14.172 18.39 20.422 7.74 8.834-15.054 14.59-32.241 16.319-50.786 6.264-67.173-43.514-127.358-110.667-133.835z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.699 117.038c-11.3 2.064-21.85 5.906-31.437 11.203-13.855 7.656-6.272 29.881 9.213 26.959.489-.092.98-.181 1.472-.267 58.96-10.258 114.891 31.141 125.535 92.887.424 2.462.769 4.918 1.036 7.366 1.226 11.252 16.461 12.786 19.097 1.865 3.725-15.436 4.334-32.006 1.218-48.796-11.286-60.814-68.018-101.832-126.134-91.217z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m156.134 510h-35.602c-13.917 0-25.199-11.282-25.199-25.199v-52.134h86v52.134c0 13.917-11.282 25.199-25.199 25.199z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189 333.667h-28.67c-32.548 0-59.941 24.369-63.729 56.696l-10.101 86.185c0 14.991 18.089 22.827 28.813 12.352.079-.077.158-.156.237-.234l21.01-21.01c10.88-10.87 28.5-10.87 39.37 0 4.823 4.823 13.07 1.407 13.07-5.414z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.818 364c-4.842 7.792-8.086 16.719-9.217 26.363l-3.242 27.663 46.683 46.683c10.882-7.806 26.113-6.827 35.888 2.948 4.823 4.823 13.07 1.407 13.07-5.414v-98.243z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m435.634 510h-35.602c-13.917 0-25.199-11.282-25.199-25.199v-52.134h86v52.134c0 13.917-11.282 25.199-25.199 25.199z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.167 333.667h28.67c32.548 0 59.94 24.369 63.729 56.696l10.101 86.186c0 14.991-18.089 22.827-28.813 12.352-.079-.077-.158-.156-.237-.234l-21.01-21.01c-10.88-10.87-28.5-10.87-39.37 0-4.823 4.823-13.07 1.407-13.07-5.414z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.566 390.363c-3.789-32.327-31.181-56.696-63.729-56.696h-28.669v72.5l87.394 87.394c7.967-1.004 15.106-7.594 15.106-17.012z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m457.399 318.03 10.101 86.186c0 14.991-18.089 22.827-28.813 12.352-.079-.078-.158-.156-.237-.234l-21.01-21.01c-10.88-10.87-28.5-10.87-39.37 0l-21.01 21.01c-10.872 10.872-28.498 10.872-39.37 0l-21.01-21.01c-10.869-10.869-28.491-10.869-39.36 0l-21.01 21.01c-10.872 10.872-28.498 10.872-39.37 0l-21.01-21.01c-10.87-10.87-28.49-10.87-39.37 0l-21.01 21.01c-.079.079-.158.157-.237.234-10.724 10.475-28.813 2.639-28.813-12.352l10.101-86.186c3.789-32.327 31.181-56.696 63.729-56.696h233.34c32.548-.001 59.94 24.369 63.729 56.696z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.399 318.03c-3.789-32.327-31.181-56.696-63.729-56.696h-233.34c-32.548 0-59.94 24.369-63.729 56.696l-4.449 37.956 41.872 41.873 2.535-2.535c10.88-10.87 28.5-10.87 39.37 0l21.01 21.01c10.872 10.872 28.498 10.872 39.37 0l21.01-21.01c10.869-10.869 28.491-10.869 39.36 0l21.01 21.01c10.872 10.872 28.498 10.872 39.37 0l21.01-21.01c10.87-10.87 28.49-10.87 39.37 0l21.01 21.01c.079.079.158.157.237.234 10.724 10.475 28.813 2.638 28.813-12.352z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.399 277.333 10.101 65.882c0 14.991-18.089 22.827-28.813 12.352-.079-.078-.158-.156-.237-.234l-21.01-21.01c-10.88-10.87-28.5-10.87-39.37 0l-21.01 21.01c-10.872 10.872-28.498 10.872-39.37 0l-21.01-21.01c-10.869-10.869-28.491-10.869-39.36 0l-21.01 21.01c-10.872 10.872-28.498 10.872-39.37 0l-21.01-21.01c-10.87-10.87-28.49-10.87-39.37 0l-21.01 21.01c-.079.079-.158.157-.237.234-10.724 10.475-28.813 2.639-28.813-12.352l10.101-65.882c3.789-32.327 31.181-56.696 63.729-56.696h233.34c32.548 0 59.94 24.369 63.729 56.696z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.67 220.637h-80.233l-7.937 79.363 53.447 53.447 19.123-19.124c10.87-10.87 28.49-10.87 39.37 0l21.01 21.01c.079.079.158.157.237.234 10.724 10.475 28.813 2.638 28.813-12.352l-10.101-65.882c-3.789-32.327-31.181-56.696-63.729-56.696z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.068 280.215-19.28-142.882h-127.518l-15.61 147.357c-1.031 9.731 7.196 18.602 18.424 19.236 2.579.145 4.828-.23 6.396-1.592l34.621-31.01c12.515-10.87 32.802-10.87 45.329 0l24.19 21.01c.091.079.182.157.273.234 12.348 10.475 33.175 2.638 33.175-12.353z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.787 137.333h-127.517l-4.24 40.03 97.655 97.655 19.936 17.316c.09.079.182.157.273.234 12.347 10.475 33.174 2.639 33.174-12.352z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.645 84.145-99.189-23.332c-6.33-1.489-12.134-4.983-16.709-10.06l-41.563-46.117c-8.925-9.903-24.184-2.89-24.184 11.114v137.968c0 15.804 13.294 28.615 29.692 28.615h142.207c22.699 0 41.101-17.734 41.101-39.609v-20.099c0-18.258-12.95-34.15-31.355-38.48z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.388 131.11c-12.141 0-21.983-9.842-21.983-21.983v-11.273c0-12.141 9.842-21.983 21.983-21.983 12.141 0 21.983 9.842 21.983 21.983v11.273c0 12.141-9.842 21.983-21.983 21.983z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.645 84.145-7.68-1.807c-15.027 14.974-24.289 35.354-24.289 57.831 0 15.392 4.353 29.796 11.912 42.164h10.312c22.699 0 41.101-17.734 41.101-39.609v-20.099c-.001-18.258-12.951-34.15-31.356-38.48z",
    fill: "url(#SVGID_18_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinata);
export default __webpack_public_path__ + "static/media/icon-pinata.2dccd880a0fd81f25ceca5a658f43d01.svg";
export { ForwardRef as ReactComponent };